<template>
  <div>
    <ca-row>
      <ca-col size="6">
        <ca-field
          label="Nome">
          <ca-input
            v-model="basicData.name"
            maxlength="60"
            required></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <ca-field
          label="Matrícula do eSocial"
          icon-tooltip="A matrícula deve ser igual à do
          cadastro do eSocial. Se você
          estiver efetuando o primeiro
          cadastro, crie a matrícula por
          aqui. Ela será utilizada sempre
          que você transmitir eventos
          pelo eSocial.">
          <e-social-registration-input
            v-model="basicData.registration"
            required>
          </e-social-registration-input>
          <small>Não são permitidos espaços no início ou no fim da matrícula.</small>
        </ca-field>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="6">
        <ca-field label="Email">
          <ca-input v-model="basicData.email" maxlength="70"></ca-input>
        </ca-field>
      </ca-col>

      <ca-col size="6">
        <worker-stocking-select
          v-model="basicData.allocation.id"
          :refresh-form="refreshForm" />
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="6">
        <worker-job-description-select
          v-model="basicData.jobDescription"
          :refresh-form="refreshForm" />
      </ca-col>

      <ca-col size="6">
        <worker-union-select
          v-model="basicData.union"
          :refresh-form="refreshForm" />
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="6">
        <ca-field
          label="Situação no eSocial"
          icon-tooltip="'Novo' para trabalhadores que foram admitidos antes
                da obrigatoriedade do eSocial, 'Admissão' para trabalhadores admitidos
                a partir do início da obrigatoriedade, 'Alterado' para habilitar o envio
                alterações no contrato e 'Sincronizado' se o trabalhador já foi enviado
                por outro sistema.">
          <ca-select
            v-model="basicData.esocialStatus"
            compare-value-by="name"
            :on-change="refreshForm">
            <ca-option
              v-for="status in esocialStatus"
              :key="status.name"
              :value="status">
              {{ status.description }}
            </ca-option>
          </ca-select>
          <small>
            <ca-link @click="openESocialSituationInfoModal">
              Como preencher a situação do cadastro no eSocial?
            </ca-link>
          </small>
        </ca-field>
      </ca-col>
    </ca-row>
  </div>
</template>

<script>
import { ESOCIAL_FILTER } from '../../workerConstants';
import WorkerUnionSelect from './WorkerUnionSelect';
import WorkerJobDescriptionSelect from './WorkerJobDescriptionSelect';
import WorkerStockingSelect from './WorkerStockingSelect';
import ESocialSituationInfoModal from '../../modals/ESocialSituationInfoModal.vue';

export default {
  name: 'WorkerBasicDataForm',
  components: {
    WorkerJobDescriptionSelect,
    WorkerUnionSelect,
    WorkerStockingSelect,
  },
  props: {
    basicData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    misc() {
      return this.$store.state.misc;
    },
    esocialStatus() {
      return this.misc.esocialStatus[ESOCIAL_FILTER];
    },
  },
  created() {
    this.$store.dispatch('misc/getEsocialStatus', ESOCIAL_FILTER);
  },
  methods: {
    openESocialSituationInfoModal() {
      ESocialSituationInfoModal.open({});
    },
    async refreshForm() {
      await this.$nextTick();
      this.$emit('refresh-form');
    },
  },
};
</script>
